<style>
</style>
<template>
  <div>
    <fullscreen ref="fullscreen" @change="fullscreenChange" fullscreen-class="p-10 bg-white">
      <div class="w-full px-6">
          <vs-button :to="`/luminarias/${uuid}`" class="w-full sm:w-auto" color="primary" type="filled">{{$t('Labels.Back')}}</vs-button>
          <vs-button @click="toggle" class="p-1" color="white" type="flat">
          <iconBase class="align-middle" iconName="filter_list" :width="28" :height="28" iconColor="#626262">
              <iconFullscreen v-show="!fullscreen"/>
              <iconExitfullscreen v-show="fullscreen"/>
            </iconBase>
            <span v-show="!fullscreen" class="text-grey-dark font-bold align-middle ml-2">Ver en pantalla completa</span>
            <span v-show="fullscreen" class="text-grey-dark font-bold align-middle ml-2">Salir de pantalla completa</span>
          </vs-button>
      </div>
      <v-select class="w-1/3 block my-6" :options="options" v-model="optionSelected" :reduce="v => v.value"/>
      <div class="w-full sm:w-1/3 sm:inline-block">
        <div class="text-center">{{$t('Labels.Current')}}</div>
        <vue-apex-charts v-if="currentToday.loaded" type="area" height="350" :options="optionsToday" :series="currentToday.data"></vue-apex-charts>
      </div>
      <div class="w-full sm:w-1/3 sm:inline-block">
        <div class="text-center">{{$t('Labels.ActiveEnergy')}}</div>
        <vue-apex-charts v-if="currentToday.loaded" type="area" height="350" :options="optionsToday" :series="activeEnergyToday.data"></vue-apex-charts>
      </div>
      <div class="w-full sm:w-1/3 sm:inline-block">
        <div class="text-center">{{$t('Labels.ReactiveEnergy')}}</div>
        <vue-apex-charts v-if="currentToday.loaded" type="area" height="350" :options="optionsToday" :series="reactiveEnergyToday.data"></vue-apex-charts>
      </div>
      <div class="w-full sm:w-1/3 sm:inline-block">
        <div class="text-center">{{$t('Labels.PowerFactor')}}</div>
        <vue-apex-charts v-if="currentToday.loaded" type="area" height="350" :options="optionsToday" :series="powerFactorToday.data"></vue-apex-charts>
      </div>
      <div class="w-full sm:w-1/3 sm:inline-block">
        <div class="text-center">{{$t('Labels.Frequency')}}</div>
        <vue-apex-charts v-if="currentToday.loaded" type="area" height="350" :options="optionsToday" :series="frequencyToday.data"></vue-apex-charts>
      </div>
      <div class="w-full sm:w-1/3 sm:inline-block">
        <div class="text-center">{{$t('Labels.Dimming')}}</div>
        <vue-apex-charts v-if="currentToday.loaded" type="area" height="350" :options="optionsToday" :series="dimmingToday.data"></vue-apex-charts>
      </div>
      <div class="w-full sm:w-1/3 sm:inline-block">
        <div class="text-center">{{$t('Labels.ActivePower')}}</div>
        <vue-apex-charts v-if="currentToday.loaded" type="area" height="350" :options="optionsToday" :series="activePowerToday.data"></vue-apex-charts>
      </div>
      <div class="w-full sm:w-1/3 sm:inline-block">
        <div class="text-center">{{$t('Labels.ApparentPower')}}</div>
        <vue-apex-charts v-if="currentToday.loaded" type="area" height="350" :options="optionsToday" :series="apparentPowerToday.data"></vue-apex-charts>
      </div>
      <div class="w-full sm:w-1/3 sm:inline-block">
        <div class="text-center">{{$t('Labels.ReactivePower')}}</div>
        <vue-apex-charts v-if="currentToday.loaded" type="area" height="350" :options="optionsToday" :series="reactivePowerToday.data"></vue-apex-charts>
      </div>
    </fullscreen>
  </div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts'
import {request} from '@/request.js'
import fullscreen from 'vue-fullscreen/src/component.vue'
import iconBase from '@/components/icons/iconBase'
import iconFullscreen from '@/components/icons/iconFullscreen'
import iconExitfullscreen from '@/components/icons/iconExitfullscreen'
import vSelect from 'vue-select'

export default {
  components: {
    VueApexCharts,
    fullscreen,
    iconBase,
    iconFullscreen,
    iconExitfullscreen,
    'v-select': vSelect
  },
  data () {
    return {
      trigoStrength: 3,
      isReady: false,
      fullscreen: false,
      currentToday:{
        data:[],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels:[],
        options:{}
      },
      activeEnergyToday:{
        data:[],
        dataAvg: [],
        dataMax: [],
        dataMin: []
      },
      reactiveEnergyToday:{
        data:[],
        dataAvg: [],
        dataMax: [],
        dataMin: []
      },
      powerFactorToday:{
        data:[],
        dataAvg: [],
        dataMax: [],
        dataMin: []
      },
      frequencyToday:{
        data:[],
        dataAvg: [],
        dataMax: [],
        dataMin: []
      },
      dimmingToday:{
        data:[],
        dataAvg: [],
        dataMax: [],
        dataMin: []
      },
      apparentPowerToday:{
        data:[],
        dataAvg: [],
        dataMax: [],
        dataMin: []
      },
      activePowerToday:{
        data:[],
        dataAvg: [],
        dataMax: [],
        dataMin: []
      },
      reactivePowerToday:{
        data:[],
        dataAvg: [],
        dataMax: [],
        dataMin: []
      },
      optionsToday:{
        colors:['#ff0000', '#626262', '#1fbee5'],
        chart: {
          height: 350,
          type: 'line',
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: 3,
          curve: 'smooth',
          dashArray: 0
        },
        fill: {
          type: 'gradient',
          gradient: {
            opacityFrom: 0.6,
            opacityTo: 0.8
          }
        },
        title: {
          text: '',
          align: 'left'
        },
        xaxis: {
          categories: []
        },
        grid: {
          borderColor: '#f1f1f1'
        },
        tooltip: {
          y: {
            formatter (val) {
              return `${val  }w`
            }
          }
        }
      },
      uuid: this.$route.params.uuid,
      options:[
        {label: this.$t('Labels.Last24Hours'), value: 'day'},
        {label: this.$t('Labels.LastWeek'), value: 'week'},
        {label: this.$t('Labels.LastMonth'), value: 'month'}
      ],
      optionSelected: 'day'
    }
  },
  methods: {
    toggle () {
      this.$refs['fullscreen'].toggle() 
    },
    fullscreenChange (fullscreen) {
      this.fullscreen = fullscreen
    },
    async getLastDay () {
      this.$vs.loading()
      const params = {
        url: `luminaires_devices/${this.uuid}/stadistics_last_day`,
        method: 'GET'
      }
      await request(params).then(response => {
        const api = this
        this.reset()

        response.data.data.forEach(function (item) {
          api.currentToday.labels.push(item.hora)
          api.pushData(item)
        })
        this.pushSeries()

        this.optionsToday.xaxis.categories = this.currentToday.labels     
        this.currentToday.loaded = true 

      }).finally(() => {
        this.$vs.loading.close()
      })  
    },
    async getLastWeek () {
      this.$vs.loading()
      const params = {
        url: `luminaires_devices/${this.uuid}/stadistics_last_week`,
        method: 'GET'
      }
      await request(params).then(response => {
        const api = this
        this.reset()

        response.data.data.forEach(function (item) {
          api.currentToday.labels.push(item.day)
          api.pushData(item)
        })
        this.pushSeries()
        this.optionsToday.xaxis.categories = this.currentToday.labels 
        this.currentToday.loaded = true 

      }).finally(() => {
        this.$vs.loading.close()
      })  
    },
    async getLastMonth () {
      this.$vs.loading()
      const params = {
        url: `luminaires_devices/${this.uuid}/stadistics_last_month`,
        method: 'GET'
      }
      await request(params).then(response => {
        const api = this
        this.reset()

        response.data.data.forEach(function (item) {
          api.currentToday.labels.push(item.day)
          api.pushData(item)
        })
        this.pushSeries()
        this.currentToday.options = this.optionsToday
        this.currentToday.options.xaxis.categories = this.currentToday.labels     
        this.currentToday.loaded = true 

      }).finally(() => {
        this.$vs.loading.close()
      })  
    },
    pushData (item) {
      const api = this
      api.currentToday.dataAvg.push(parseFloat(item.promedio_corriente || 0).toFixed(2))
      api.currentToday.dataMin.push(parseFloat(item.minimo_corriente || 0).toFixed(2))
      api.currentToday.dataMax.push(parseFloat(item.maximo_corriete || 0).toFixed(2))

      api.activeEnergyToday.dataAvg.push(parseFloat(item.promedio_energia_activa || 0).toFixed(2))
      api.activeEnergyToday.dataMin.push(parseFloat(item.minimo_energia_activa || 0).toFixed(2))
      api.activeEnergyToday.dataMax.push(parseFloat(item.maximo_energia_activa || 0).toFixed(2))

      api.reactiveEnergyToday.dataAvg.push(parseFloat(item.promedio_energia_reactiva || 0).toFixed(2))
      api.reactiveEnergyToday.dataMin.push(parseFloat(item.minimo_energia_reactiva || 0).toFixed(2))
      api.reactiveEnergyToday.dataMax.push(parseFloat(item.maximo_energia_reactiva || 0).toFixed(2))

      api.powerFactorToday.dataAvg.push(parseFloat(item.promedio_factor_potencia || 0).toFixed(2))
      api.powerFactorToday.dataMin.push(parseFloat(item.minimo_factor_potencia || 0).toFixed(2))
      api.powerFactorToday.dataMax.push(parseFloat(item.maximo_factor_potencia || 0).toFixed(2))
      
      api.frequencyToday.dataAvg.push(parseFloat(item.promedio_factor_potencia || 0).toFixed(2))
      api.frequencyToday.dataMin.push(parseFloat(item.minimo_factor_potencia || 0).toFixed(2))
      api.frequencyToday.dataMax.push(parseFloat(item.maximo_factor_potencia || 0).toFixed(2))

      api.dimmingToday.dataAvg.push(parseFloat(item.promedio_intensidad || 0).toFixed(2))
      api.dimmingToday.dataMin.push(parseFloat(item.minimo_intensidad || 0).toFixed(2))
      api.dimmingToday.dataMax.push(parseFloat(item.maximo_intensidad || 0).toFixed(2))

      
      api.activePowerToday.dataAvg.push(parseFloat(item.promedio_potencia_activa || 0).toFixed(2))
      api.activePowerToday.dataMin.push(parseFloat(item.minimo_potencia_activa || 0).toFixed(2))
      api.activePowerToday.dataMax.push(parseFloat(item.maximo_potencia_activa || 0).toFixed(2))

      api.apparentPowerToday.dataAvg.push(parseFloat(item.promedio_potencia_aparente || 0).toFixed(2))
      api.apparentPowerToday.dataMin.push(parseFloat(item.minimo_potencia_aparente || 0).toFixed(2))
      api.apparentPowerToday.dataMax.push(parseFloat(item.maximo_potencia_aparente || 0).toFixed(2))

      api.reactivePowerToday.dataAvg.push(parseFloat(item.promedio_potencia_reactiva || 0).toFixed(2))
      api.reactivePowerToday.dataMin.push(parseFloat(item.minimo_potencia_reactiva || 0).toFixed(2))
      api.reactivePowerToday.dataMax.push(parseFloat(item.maximo_potencia_reactiva || 0).toFixed(2))
    },
    pushSeries () {
      this.currentToday.data = [
        {
          name: this.$t('Labels.Max'),
          data: this.currentToday.dataMax
        },
        {
          name: this.$t('Labels.Avg'),
          data: this.currentToday.dataAvg
        },
        {
          name: this.$t('Labels.Min'),
          data: this.currentToday.dataMin
        }
      ]

      this.activeEnergyToday.data = [
        {
          name: this.$t('Labels.Max'),
          data: this.activeEnergyToday.dataMax
        },
        {
          name: this.$t('Labels.Avg'),
          data: this.activeEnergyToday.dataAvg
        },
        {
          name: this.$t('Labels.Min'),
          data: this.activeEnergyToday.dataMin
        }
      ]

      this.reactiveEnergyToday.data = [
        {
          name: this.$t('Labels.Max'),
          data: this.reactiveEnergyToday.dataMax
        },
        {
          name: this.$t('Labels.Avg'),
          data: this.reactiveEnergyToday.dataAvg
        },
        {
          name: this.$t('Labels.Min'),
          data: this.reactiveEnergyToday.dataMin
        }
      ]

      this.powerFactorToday.data = [
        {
          name: this.$t('Labels.Max'),
          data: this.powerFactorToday.dataMax
        },
        {
          name: this.$t('Labels.Avg'),
          data: this.powerFactorToday.dataAvg
        },
        {
          name: this.$t('Labels.Min'),
          data: this.powerFactorToday.dataMin
        }
      ]

      this.frequencyToday.data = [
        {
          name: this.$t('Labels.Max'),
          data: this.frequencyToday.dataMax
        },
        {
          name: this.$t('Labels.Avg'),
          data: this.frequencyToday.dataAvg
        },
        {
          name: this.$t('Labels.Min'),
          data: this.frequencyToday.dataMin
        }
      ]

      this.dimmingToday.data = [
        {
          name: this.$t('Labels.Max'),
          data: this.dimmingToday.dataMax
        },
        {
          name: this.$t('Labels.Avg'),
          data: this.dimmingToday.dataAvg
        },
        {
          name: this.$t('Labels.Min'),
          data: this.dimmingToday.dataMin
        }
      ]

      this.activePowerToday.data = [
        {
          name: this.$t('Labels.Max'),
          data: this.activePowerToday.dataMax
        },
        {
          name: this.$t('Labels.Avg'),
          data: this.activePowerToday.dataAvg
        },
        {
          name: this.$t('Labels.Min'),
          data: this.activePowerToday.dataMin
        }
      ]

      this.apparentPowerToday.data = [ 
        {
          name: this.$t('Labels.Max'),
          data: this.apparentPowerToday.dataMax
        },
        {
          name: this.$t('Labels.Avg'),
          data: this.apparentPowerToday.dataAvg
        },
        {
          name: this.$t('Labels.Min'),
          data: this.apparentPowerToday.dataMin
        }
      ]

      this.reactivePowerToday.data = [
        {
          name: this.$t('Labels.Max'),
          data: this.reactivePowerToday.dataMax
        },
        {
          name: this.$t('Labels.Avg'),
          data: this.reactivePowerToday.dataAvg
        },
        {
          name: this.$t('Labels.Min'),
          data: this.reactivePowerToday.dataMin
        }
      ]
    },
    reset () {
      this.currentToday = {
        data:[],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels:[],
        options:{}
      }

      this.optionsToday.xaxis.categories = []
      this.activeEnergyToday.data = []
      this.activeEnergyToday.dataAvg = []
      this.activeEnergyToday.dataMax = []
      this.activeEnergyToday.dataMin = []

      this.reactiveEnergyToday.data = []
      this.reactiveEnergyToday.dataAvg = []
      this.reactiveEnergyToday.dataMax = []
      this.reactiveEnergyToday.dataMin = []

      this.powerFactorToday.data = []
      this.powerFactorToday.dataAvg = []
      this.powerFactorToday.dataMax = []
      this.powerFactorToday.dataMin = []

      this.frequencyToday.data = []
      this.frequencyToday.dataAvg = []
      this.frequencyToday.dataMax = []
      this.frequencyToday.dataMin = []

      this.dimmingToday.data = []
      this.dimmingToday.dataAvg = []
      this.dimmingToday.dataMax = []
      this.dimmingToday.dataMin = []

      this.apparentPowerToday.data = []
      this.apparentPowerToday.dataAvg = []
      this.apparentPowerToday.dataMax = []
      this.apparentPowerToday.dataMin = []

      this.activePowerToday.data = []
      this.activePowerToday.dataAvg = []
      this.activePowerToday.dataMax = []
      this.activePowerToday.dataMin = []

      this.reactivePowerToday.data = []
      this.reactivePowerToday.dataAvg = []
      this.reactivePowerToday.dataMax = []
      this.reactivePowerToday.dataMin = []
    }
  },
  mounted () {
    this.isReady = true
    this.getLastDay()
  },
  watch: {
    optionSelected (val) {
      this.currentToday.loaded = false 
      if (val === 'day') this.getLastDay()
      else if (val === 'month') this.getLastMonth()
      else this.getLastWeek()
    }
  }
}
</script>